import { postAction } from './postAction'

// Redrives performance-update events. Passing a tenantGroupCode scopes the redrive
// to that single group; passing null omits the body entirely for a full redrive of
// every tenant group. Note the singular field name (tenantGroupCode) — distinct from
// the plural tenantGroupCodes array on the rebuild endpoint.
export async function redrivePerformanceUpdate(
  token: string,
  tenantGroupCode: string | null,
): Promise<string> {
  const body = tenantGroupCode ? { tenantGroupCode } : undefined
  const result = await postAction(
    '/v1/act/redrive/performance_update',
    token,
    body,
  )
  return result.message ?? 'Performance update redrive request accepted.'
}
